export const webInfo = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    mapBoxToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
}

